import { Image } from '@/atoms/Image'
import { useTranslate } from '@/utils/translate/translate-client'
import { DavidButton } from './DavidButton'

function PosterTitles() {
  return (
    <div
      className="aspect-square md:aspect-auto relative w-full shrink-0 rounded-[24px] md:min-h-px md:min-w-px md:grow md:basis-0 md:self-stretch"
      data-name="poster titles"
    >
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 rounded-[24px]">
        <div className="absolute inset-0 rounded-[24px] bg-[#7b7979]" />
        <Image
          alt=""
          className="rounded-[24px] object-cover"
          src="/v1762369202/theatrical/david/paper-canvas-distressed-rough-01-web"
          fill
          sizes="(max-width: 768px) 100vw, 50vw"
        />
      </div>
      <div className="flex size-full flex-col items-center justify-center">
        <div className="relative box-border flex h-auto w-full flex-col content-stretch items-center justify-center gap-[8px] px-[16px] py-[40px] md:size-full md:py-[180px]">
          <div className="aspect-[352/91] aspect-auto relative h-[91px] w-[70%] shrink-0" data-name="david-logo">
            <Image
              alt=""
              className="pointer-events-none object-contain"
              src="/v1761067809/theatrical/david/david-logo-color"
              fill
              sizes="352px"
            />
          </div>
          <p className="font-angel-royal relative shrink-0 whitespace-pre text-nowrap text-center text-[40px] lowercase not-italic leading-[48px] tracking-[0.5px] text-[#411e09]">
            vs.
          </p>
          <div className="relative h-auto w-[85%] shrink-0 md:h-auto md:w-auto" data-name="avatar-fire-ash-logo 1">
            <Image
              alt=""
              className="pointer-events-none h-auto w-full object-contain md:h-[104px] md:w-auto"
              src="/v1760675186/theatrical/david/goliath-box-office-titles-02"
              width={400}
              height={104}
              sizes="(max-width: 768px) 85vw, 400px"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export function DavidGoliathSection() {
  const { t } = useTranslate('pif')

  return (
    <section className="relative w-full px-[16px] py-[96px] md:px-[64px] md:py-[200px]" data-name="david-goliath">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-[#faf0e7]" />
        <Image
          alt=""
          className="object-cover opacity-[0.55] mix-blend-color-burn"
          src="/v1760914561/theatrical/david/dirt-texture-on-white-01"
          fill
          sizes="100vw"
          loading="lazy"
        />
      </div>
      <div
        className="relative mx-auto flex w-full max-w-[1440px] shrink-0 flex-col content-stretch items-start gap-[40px] md:flex-row md:gap-0"
        data-name="container-50-flip"
      >
        <PosterTitles />
        <div className="relative w-full shrink-0 md:min-h-px md:min-w-px md:grow md:basis-0 md:self-stretch">
          <div className="flex size-full flex-col justify-center">
            <div className="relative box-border flex w-full flex-col content-stretch items-start justify-center gap-[32px] p-0 md:size-full md:gap-[40px] md:py-[64px] md:pl-[64px] md:pr-0">
              <div className="relative flex w-full shrink-0 flex-col content-stretch items-start gap-[12px] not-italic">
                <p className="font-angel-royal relative w-full shrink-0 text-[40px] lowercase not-italic leading-[40px] text-[#141447] md:text-[64px] md:leading-[64px]">
                  {t('davidGoliathMomentTitle', 'a True David & Goliath Moment')}
                </p>
                <div className="font-whitney-medium relative w-full shrink-0 text-[0px] leading-[0]">
                  <p className="font-whitney-medium md:font-whitney-medium relative mb-0 w-full shrink-0 text-[16px] not-italic leading-[24px] text-[#141447] md:text-[18px] md:leading-[28px]">
                    <span className="font-whitney-medium-italic italic">DAVID</span>
                    <span className="font-whitney-medium not-italic">
                      {t(
                        'davidGoliathParagraph1',
                        ' hits theaters December 19—the same week Avatar: Fire and Ash lands on screens nationwide. Just like the original story, this is a true underdog moment.',
                      )}
                    </span>
                  </p>
                  <p className="mb-0 text-[1rem] leading-[28px] md:text-[18px] md:leading-[30px]">&nbsp;</p>
                  <p className="font-whitney-medium md:font-whitney-medium relative w-full shrink-0 text-[16px] not-italic leading-[24px] text-[#141447] md:text-[18px] md:leading-[28px]">
                    <span className="font-whitney-medium not-italic">
                      {t(
                        'davidGoliathParagraph2Part1',
                        "By Paying it Forward, you're doing more than helping kids see ",
                      )}
                    </span>
                    <span className="font-whitney-medium-italic italic">DAVID</span>
                    <span className="font-whitney-medium not-italic">
                      {t(
                        'davidGoliathParagraph2Part2',
                        " for free—you're also telling theaters that this story matters and deserves a place on screens across the country. Let's show the world that a story about courage, faith, and light can stand tall—no matter the giant.",
                      )}
                    </span>
                  </p>
                </div>
              </div>
              <div
                className="relative flex w-full shrink-0 flex-col content-stretch items-start gap-[8px] md:w-auto md:flex-row"
                data-name="button-set"
              >
                <DavidButton variant="dark" openPifOverlay className="w-full md:w-auto">
                  {t('payItForward', 'Pay it Forward')}
                </DavidButton>
                <DavidButton variant="cyan" href="/tickets/david" className="w-full md:w-auto">
                  {t('getShowtimes', 'Get Showtimes')}
                </DavidButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
